<template>
  <div class="UploadingBox right">
    <div class="__container">
      <div class="__loading" v-if="!display_error">
        <div class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="box-uploading-failed" v-else>
        <v-icon>mdi-alert</v-icon> <span>Can't upload file</span>
      </div>
      <div class="file-name" :title="file_name">{{ file_name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    file_name: "",
    status: ""
  },
  data() {
    return {
    };
  },
  mounted() {
    
  },
  computed: {
    display_error() {
      if (this.status && this.status === 'failed') {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #6D9CCB;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #6D9CCB transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.UploadingBox {
  width: 100%;
  margin-top: 5px;
  position: relative;
  opacity: 0.7;
}

.UploadingBox .__container {
  width: 200px;
  height: 120px;
  background-color: #ececec;
  border-radius: 20px;
  float: right;
  text-align: center;
  position: relative;
  /* margin-right: 4px; */
}

.UploadingBox .__container::after {
  /* content: ''; */
  position: absolute;
  top: 12px;
  right: -7px;
  margin: 5px 0 0 -10px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #2a4e69;
}

.UploadingBox .__container .__loading {
  position: relative;
  top: calc(50% - 50px);
}

.UploadingBox .file-name {
  width: 100%;
  position: absolute;
  bottom: 10px;
  /* color: #fff; */
  padding: 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.UploadingBox .box-uploading-failed {
  margin-top: 20px;
}

.UploadingBox .box-uploading-failed i {
  font-size: 50px;
  color: #f00;
}

.UploadingBox .box-uploading-failed span {
  display: block;
  margin: 5px 0;
  color: #f00;
}
</style>